import { Unit } from '@rematter/frontend-lib-api-client';
import { useAtomValue } from 'jotai';

import {
  convertQuantity,
  formatQuantityWithConversion,
  formatUnit,
} from '../utils/unitConversion';

import {
  $inventoryDefaultDisplayUnit,
  inventoryDisplayUnitToUnit,
} from '~/shared/state/settings.state';

export type UseInventoryUnitReturn = {
  displayUnit: Unit | null;
  formatQuantityValue: (
    value: number,
    itemUnit: Unit,
    options?: {
      minimumFractionDigits?: number;
      maximumFractionDigits?: number;
      showUnit?: boolean;
    },
  ) => string;
  getDisplayValue: (value: number, itemUnit: Unit) => number;
  getDisplayUnit: (itemUnit: Unit) => Unit;
  formatUnitLabel: (unit: Unit) => string;
};

export const useInventoryUnit = (): UseInventoryUnitReturn => {
  const displayUnitSetting = useAtomValue($inventoryDefaultDisplayUnit);
  const displayUnit = inventoryDisplayUnitToUnit(displayUnitSetting);

  const formatQuantityValue = (
    value: number,
    itemUnit: Unit,
    options?: {
      minimumFractionDigits?: number;
      maximumFractionDigits?: number;
      showUnit?: boolean;
    },
  ): string =>
    formatQuantityWithConversion(value, itemUnit, displayUnit, options);

  const getDisplayValue = (value: number, itemUnit: Unit): number => {
    if (displayUnit === null) {
      return value;
    }
    return convertQuantity(value, itemUnit, displayUnit);
  };

  const getDisplayUnit = (itemUnit: Unit): Unit => displayUnit ?? itemUnit;

  const formatUnitLabel = (unit: Unit): string => formatUnit(unit);

  return {
    displayUnit,
    formatQuantityValue,
    getDisplayValue,
    getDisplayUnit,
    formatUnitLabel,
  };
};
